import { BigHeading } from "@components/SiteShell"
import WorkDetails from "@components/WorkDetails"
import * as m from "@paraglide/messages"
import type { WorkPageData } from "@site-types/publicPageData"
import type { SupportedLocale as Lang } from "@site-types/site"

export function WorkPage({ data, locale }: { data: WorkPageData; locale: Lang }) {
  return (
    <>
      <BigHeading>{(m.work_heading_label({}, { locale: locale }) || "Our Work").toUpperCase()}</BigHeading>
      <WorkDetails
        data={data}
        locale={locale}
      />
    </>
  )
}
